const ADD_VIDEO_SOURCES = 'ADD_VIDEO_SOURCES';
const RESET_VIDEO_SOURCE = 'RESET_VIDEO_SOURCE';

const VIDEO_SOURCES = 'catapult:videoSources';

const INITIAL_STATE = {
  src: null,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_VIDEO_SOURCES:
      return action.payload;
    case RESET_VIDEO_SOURCE:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export function setVideoSources() {
  const videoSources = JSON.parse(localStorage.getItem(VIDEO_SOURCES) ?? '{}');

  return {
    type: ADD_VIDEO_SOURCES,
    payload: { ...videoSources },
  };
}

export function addVideoSources(videoSources) {
  localStorage.setItem(VIDEO_SOURCES, JSON.stringify(videoSources));

  return {
    type: ADD_VIDEO_SOURCES,
    payload: { ...videoSources },
  };
}

export function resetVideoSources() {
  return {
    type: RESET_VIDEO_SOURCE,
  };
}
